import { api } from "@/services/api";
import { light } from "@/services/light";
import { lightSandbox } from "@/services/lightSandbox";
import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "../slices/lightAuth";
import { sentryMiddleware } from "./sentry";

export const store = configureStore({
  middleware: (m) =>
    m()
      .prepend(sentryMiddleware.middleware)
      .concat(api.middleware, light.middleware, lightSandbox.middleware),
  reducer: {
    [api.reducerPath]: api.reducer,
    [light.reducerPath]: light.reducer,
    [lightSandbox.reducerPath]: lightSandbox.reducer,
    [authSlice.reducerPath]: authSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
